import config from 'config';
import useAxios, { RefetchOptions } from 'axios-hooks';
import { AxiosError, AxiosPromise, AxiosRequestConfig } from 'axios';
import { useAppContext } from '../../context/appContext';
import { useKeycloak } from '../../auth/keycloak';

const url: string = config.api.url;

declare type UsePatchResult<T> = {
  patchData: any;
  patchError: AxiosError<T>;
  patchLoading: boolean;
  executePatch: (config?: AxiosRequestConfig, options?: RefetchOptions) => AxiosPromise<T>;
};

type UsePatchRequestProps = {
  path: string;
  headers?: unknown;
};
export function usePatchRequest<Result = unknown>({ path, headers }: UsePatchRequestProps) : UsePatchResult<Result> {
  const {
    settings: { issuer, routeIssuer },
  } = useAppContext();
  const { keycloak } = useKeycloak();

  keycloak
    .updateToken(5)
    .then(() => {
      localStorage.setItem('kc_token', keycloak.token);
      localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
    })
    .catch(() => keycloak.login());

  const [{ data: patchData, loading: patchLoading, error: patchError }, executePatch] =
    useAxios(
      {
        url: url + "/" + path,
        method: 'PATCH',
        // @ts-ignore
        headers:  { ...headers, 'X-Prisma-Issuer': issuer?.name, Authorization: `Bearer ${keycloak.token}`, 'backoffice-source': routeIssuer }
      },
      { manual: true }
    )

  return {
    patchData,
    patchError,
    patchLoading,
    executePatch
  }
}

export default usePatchRequest;